import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import {
  IStandardPredictionPostRequest,
  IStandardPredictionPostResponse,
  IStandardPredictionRequest,
} from '../../interfaces/standard-prediction.interface';
import { Observable } from 'rxjs';
import { IGetStandardPredictionResponse } from '../../interfaces/standard-prediction.interface';

@Injectable({
  providedIn: 'root',
})
export class StandardPredictionService {
  constructor(
    private appSetting: AppSettings,
    private httpClient: HttpClient
  ) {}

  private formatDate(date: string | Date): string {
    if (!date) return '';

    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      return dateObj.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  getStandardPrediction(
    request: IStandardPredictionRequest
  ): Observable<IGetStandardPredictionResponse[]> {
    const url = this.appSetting.standardPrediction.urls.base;
    let params = new HttpParams();

    Object.entries(request).forEach(([key, value]) => {
      if (key === 'fechaInicio' || key === 'fechaFin') {
        const dateValue = value instanceof Date ? value.toISOString() : value;
        params = params.set(key, this.formatDate(dateValue));
      } else if (key === 'filters' && value) {
        Object.entries(value).forEach(([filterKey, filterValue]) => {
          if (filterKey === 'idMedidor') {
            params = params.set('cliente', String(filterValue));
          } else if (Array.isArray(filterValue)) {
            filterValue.forEach(val => {
              if (val !== null && val !== undefined) {
                params = params.append(filterKey, String(val));
              }
            });
          } else if (filterValue !== null && filterValue !== undefined) {
            params = params.append(filterKey, String(filterValue));
          }
        });
      } else if (value !== null && value !== undefined) {
        params = params.set(key, value);
      }
    });

    return this.httpClient.get<IGetStandardPredictionResponse[]>(url, {
      params,
    });
  }

  getStandardPredictionEdit(
    request: IStandardPredictionPostRequest
  ): Observable<IStandardPredictionPostResponse> {
    const url = this.appSetting.standardPrediction.urls.edit;
    return this.httpClient.post<IStandardPredictionPostResponse>(url, request);
  }

  getStandardPredictionTemporal(
    uuid: string
  ): Observable<IGetStandardPredictionResponse[]> {
    const url = this.appSetting.standardPrediction.urls.temporal;
    return this.httpClient.get<IGetStandardPredictionResponse[]>(url, {
      params: {
        uuid: uuid,
      },
    });
  }

  postGeneratePrediction(
    request: IStandardPredictionPostRequest
  ): Observable<IStandardPredictionPostResponse> {
    const url = this.appSetting.standardPrediction.urls.generate;
    return this.httpClient.post<IStandardPredictionPostResponse>(url, request);
  }
}
